import "./loadingscreen.css";

export default function LoadingScreen({ LoadingText }) {
  return (
    <main className="w-full h-screen bg-black flex flex-col justify-center items-center">
      <div className="w-[25%] h-[25%]">
        <video playsInline autoPlay loop muted src="https://datas.masalledesport.com/onair-pass-app/v2oa.mov" />
      </div>
      <p className="text-white">{LoadingText}</p>
    </main>
  );
}
